import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  TemplateRef,
  Input,
  Injectable,
  PLATFORM_ID,
  Inject,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { orderitem } from '../../../../shared/classes/orderitem';

@Component({
  selector: 'app-orders-modal',
  templateUrl: './orders-modal.component.html',
  styleUrls: ['./orders-modal.component.scss'],
})
export class OrdersModalComponent implements OnInit, OnDestroy {
  @ViewChild('ordersModal', { static: false }) OrdersModal: TemplateRef<any>;
  @Input('orderitems') orderitems: orderitem[];
  totalPrice: number = 0;
  orderId: number;
  totalItems: number = 0;
  public closeResult: string;
  public modalOpen: boolean = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router,
    private modalService: NgbModal
  ) {
    console.log('inside orders model :', this.orderitems);
    // if (this.orderitems && !Array.isArray(this.orderitems)) {
    //   this.orderitems = [this.orderitems];
    // }
    // for (let i1 = 0; this.orderitems && i1 < this.orderitems.length; i1++) {
    //   let orderItemObj = this.orderitems[i1];
    //   this.orderId = orderItemObj.orderId;
    //   this.totalPrice = this.totalPrice + orderItemObj.itemPrice;
    //   this.totalItems = this.totalItems + orderItemObj.quantity;
    // }
  }

  ngOnInit(): void {
    // console.log('ng on init inside orders model :', this.orderitems);
    if (this.orderitems && !Array.isArray(this.orderitems)) {
      this.orderitems = [this.orderitems];
    }
    for (let i1 = 0; this.orderitems && i1 < this.orderitems.length; i1++) {
      let orderItemObj = this.orderitems[i1];
      if(window.location.host.includes('localhost')){
      orderItemObj.itemImage = '../../../../.' + orderItemObj.itemId + '.jpeg';
    }
      // console.log('orderItemObj.prodImage', orderItemObj.itemImage);
      this.orderId = orderItemObj.orderId;
      this.totalPrice = this.totalPrice + +orderItemObj.itemPrice;
      this.totalItems = this.totalItems + +orderItemObj.quantity;
    }
    // console.log(this.totalItems, this.totalPrice, this.orderId);
  }

  openModal() {
    this.modalOpen = true;
    if (isPlatformBrowser(this.platformId)) {
      // For SSR
      const modelReferenceObj = this.modalService.open(this.OrdersModal, {
        ariaLabelledBy: 'modal-basic-title',
        centered: true,
        size: 'lg',
        windowClass: 'Quickview',
      });

      modelReferenceObj.result.then(
        (result) => {
          `Result ${result}`;
          console.log(result);
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
          // console.log('reason:', reason);
        }
      );
      console.log(this.orderitems);
      // modelReferenceObj.componentInstance.orderitems = this.orderitems;
      // modelReferenceObj.componentInstance.totalPrice = this.totalPrice;
      // modelReferenceObj.componentInstance.totalItems = this.totalItems;
      // modelReferenceObj.componentInstance.orderId = this.orderId;
    }
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  ngOnDestroy() {
    if (this.modalOpen) {
      this.modalService.dismissAll();
    }
  }
}
